import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Card Type List
@return { Array }
*/
export const getCardsTypeList = state => state.cardsTypeList

/** returns Meta Data Info
@return { Array }
*/
export const getMetaData = state => state.metaDataInfo

/** returns Card Comissions Info
@return { Array }
*/
export const getCardCommissionsInfo = state => state.cardComissions

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Agencies Provinces
@return { Array }
*/
export const getAgenciesProvinces = state => state.agenciesProvinces

/** returns Branches
@return { Array }
*/
export const getBranches = state => state.branches
